import LegalPage from './LegalPage';

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      path="/terms"
      description="Terms of Service for hellorime.com and Rime, LLC bookkeeping, payroll, cleanup, and QuickBooks services."
      effectiveDate="January 1, 2026"
    >
      <p>
        These Terms of Service govern your use of hellorime.com and general interactions with Rime, LLC.
        Specific bookkeeping, payroll, cleanup, or setup services may also be governed by a separate
        engagement agreement describing the scope, pricing, responsibilities, and other terms
        applicable to that engagement.
      </p>

      <h2>Services</h2>
      <p>
        Rime, LLC provides bookkeeping, QuickBooks setup, bookkeeping cleanup and catch-up, and managed
        payroll services.
      </p>
      <p>
        The specific services provided to a client are determined by the applicable proposal,
        service selection, or engagement agreement.
      </p>

      <h2>Bookkeeping Is Not Tax, Legal, or Investment Advice</h2>
      <p>Rime, LLC provides bookkeeping and related administrative financial services.</p>
      <p>
        Unless expressly agreed otherwise in writing, Rime, LLC does not provide legal advice, investment
        advice, audits, attest services, or income-tax return preparation.
      </p>
      <p>
        Financial statements and other reports prepared through our bookkeeping services are based
        on information supplied by the client and information available through the client's
        financial systems.
      </p>
      <p>
        Clients should consult qualified tax, legal, investment, or other professional advisers
        regarding matters requiring those services.
      </p>

      <h2>Client Responsibilities</h2>
      <p>
        Clients are responsible for providing accurate and complete information, maintaining
        appropriate access to necessary systems, reviewing information requiring their approval, and
        notifying Rime, LLC promptly of material changes or errors that may affect the services.
      </p>
      <p>
        Rime, LLC is not responsible for errors, delays, penalties, or other consequences resulting from
        incomplete, inaccurate, or untimely information supplied by a client or third party.
      </p>

      <h2>Pricing</h2>
      <p>Current standard service prices may be displayed on hellorime.com.</p>
      <p>
        Essential monthly bookkeeping is offered at the price displayed on the website for
        businesses that fall within the standard scope of that service.
      </p>
      <p>
        Businesses requiring additional work or complexity may receive a custom quote before
        services begin.
      </p>
      <p>
        Cleanup and catch-up pricing shown on the website is a starting price. Final pricing is
        determined after review of the existing books and agreed upon before cleanup work begins.
      </p>
      <p>Payroll pricing depends on team size and the applicable scope of service.</p>
      <p>Any applicable fees and payment terms will be confirmed before paid services begin.</p>

      <h2>Third-Party Platforms</h2>
      <p>
        Rime, LLC may provide services using third-party software or platforms such as QuickBooks Online,
        ADP, Paychex, scheduling services, financial institutions, or other systems selected or
        authorized by the client.
      </p>
      <p>
        Rime, LLC does not control and is not responsible for outages, errors, security incidents,
        changes, or other acts or omissions of third-party providers.
      </p>
      <p>
        Clients remain responsible for any third-party subscriptions or fees unless otherwise agreed
        in writing.
      </p>

      <h2>Payroll</h2>
      <p>Managed payroll services are performed using the client's existing payroll platform.</p>
      <p>
        The client remains responsible for providing complete and accurate payroll information on
        time, including employee information, hours, compensation, deductions, benefits, and other
        information required to process payroll correctly.
      </p>
      <p>
        Specific responsibilities for payroll filings, tax payments, and related compliance will be
        defined in the applicable engagement agreement and may depend on the client's payroll
        provider.
      </p>

      <h2>Cancellations</h2>
      <p>
        Standard recurring bookkeeping and payroll services do not require a long-term commitment
        unless otherwise stated in an engagement agreement.
      </p>
      <p>
        Either party may end recurring services according to the notice and termination provisions
        contained in the applicable engagement agreement.
      </p>
      <p>Amounts owed for services already performed remain due after termination.</p>

      <h2>Website Information</h2>
      <p>
        We make reasonable efforts to keep information on hellorime.com accurate and current.
        Website content is provided for general informational purposes and does not create a client
        relationship or constitute professional advice.
      </p>
      <p>
        Submitting a contact form, sending an email, or scheduling a consultation does not by itself
        create a bookkeeping or other professional-services relationship.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        The Rime, LLC name, logo, website design, original text, graphics, and other original website
        materials are owned by Rime, LLC or used with permission and may not be reproduced or distributed
        without authorization except as permitted by law.
      </p>
      <p>Third-party names, trademarks, and logos remain the property of their respective owners.</p>

      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by applicable law, Rime, LLC will not be liable for indirect,
        incidental, special, consequential, or punitive damages arising from use of this website.
      </p>
      <p>
        Liability relating to paid client services may be further addressed in the applicable
        engagement agreement.
      </p>
      <p>Nothing in these Terms excludes liability that cannot lawfully be excluded or limited.</p>

      <h2>Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Updated Terms will be posted on this page with
        a revised effective date.
      </p>

      <h2>Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of California, without regard to
        conflict-of-law principles, except where applicable law requires otherwise.
      </p>

      <h2>Contact</h2>
      <p>Questions regarding these Terms may be sent to:</p>
      <p>
        Rime, LLC
        <br />
        <a href="mailto:contact@hellorime.com">contact@hellorime.com</a>
      </p>
    </LegalPage>
  );
}
